import { Field } from "formik";
import React from "react";
import classNames from "classnames";
const RadioInput = (props) => {
    const { errors, touched, name, children, value, enabled = true } = props;
    const inputClasses = classNames("form-check-input", {
        "is-invalid": ((errors && touched) && (errors[name] && touched[name])) || false
    });
    return (React.createElement("div", { className: "form-check custom-check" },
        React.createElement(Field, { type: "radio", name: name, className: inputClasses, value: value, id: `${name}-${value}` }),
        React.createElement("label", { className: "form-check-label", htmlFor: `${name}-${value}` },
            React.createElement("span", { className: "custom-check-text" }, children))));
};
export default RadioInput;
